<div class="row mt-5 justify-content-center">
  <div class="col-lg-4">
    <mat-card>
      <mat-card-content>
        <app-login-form submitText="forms.login.buttons.login" (onSubmit)="handleLogin($event)"></app-login-form>
      </mat-card-content>
    </mat-card>
  </div>
</div>
